import { render, staticRenderFns } from "./DepartmentListTable.vue?vue&type=template&id=1d0903f6&"
import script from "./DepartmentListTable.vue?vue&type=script&lang=js&"
export * from "./DepartmentListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports